import Button from 'components/_UI/Button';
import Ilustration from 'components/_UI/Ilustration';
import Loader from 'components/_UI/Loader';
import Text from 'components/_UI/Text';
import ToastContainer from 'components/_UI/ToastsContainer';
import useToast from 'hooks/useToast';
import React, { useEffect, useState } from 'react'
import { Edit, FileMinus, Gift, Home, Link, Mail, Plus, PlusSquare, Trash2 } from 'react-feather';
import styled from 'styled-components';
import { FullyCentered } from 'styled/alignment/Center';
import { Column } from 'styled/alignment/Column';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import { Row } from 'styled/alignment/Row';
import { useEvent } from 'context/events/Event';
import CustomFieldsForm from './CustomFieldsForm';
import customFieldsApi from 'api/requests/customFields';
import CustomFieldCard from './CustomFieldCard';
import CustomFieldsDeleteModal from './CustomFieldsDeleteModal';
import fonts from 'theme/fonts';
import { BlockContent } from 'styled/UI/BlockContent';
import CreateDrawer from './drawer/CreateDrawer';
import randomPickerApi from 'api/requests/randomPicker';
import ListDrawer from './drawer/ListDrawer';
import { useRef } from 'react'
import DetailDrawer from './drawer/DetailDrawer';
import Paginate from 'components/_UI/Paginate';
import Modal from 'components/_UI/Modal';



export default function Additional() {
    const { toast, toasts } = useToast();
    const { event } = useEvent();

    const [loading, setLoading] = useState(false);
    const [content, setContent] = useState();
    const [modalVisible, setModalVisible] = useState(false);
    const [modalVisibleDrawer, setModalVisibleDrawer] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [edit, setEdit] = useState(false);
    const [giveaways, setGiveaways] = useState([]);
    const [refreshExpenses, setRefreshExpenses] = useState(false)
    const [perPage, setPergage] = useState(0)
    const [lastPage, setLastPage] = useState(0)
    const [currentPage, setCurrentPage] = useState(0)
    const [totalItems, setTotalItems] = useState(0)
    const [firstPage, setFirstPage] = useState(0)
    const [modalDetailDrawer, setModalDetailDrawer] = useState(false)


    useEffect(() => {
        getCustomFields();
        getGiveaways()
    }, [refreshExpenses])
    const ref = useRef(null)
    function refreshData() {
        setModalVisible(false);
        setDeleteModal(false);
        setEdit(false);

        getCustomFields();
    }

    async function getCustomFields() {
        setLoading(true);

        try {
            const { data } = await customFieldsApi.get(event?.slug);
            setContent(data?.data);
            
        } catch (error) {

        } finally {
            setLoading(false);
        }
    }

    async function getGiveaways(number = 1) {
        setLoading(true);

        try {
            const { data } = await randomPickerApi.get(event?.slug, number);
          
            setGiveaways(data?.data)
            setPergage(data?.meta?.per_page)
            setFirstPage(data?.meta?.first_page)
            setLastPage(data?.meta?.last_page)
            setCurrentPage(data?.meta?.current_page)
            setTotalItems(data?.meta?.total)
             ref.current?.scrollIntoView({ behavior: 'smooth', block: 'center' })
        } catch (error) {

        } finally {
            setLoading(false);
        }
    }

    async function deleteGiveaway(id) {
       
        setLoading(true)

        try {
            await randomPickerApi.delete(event?.slug, id);
            handleSuccess()
        } catch (error) {
        } finally {
            setLoading(false)
        }
    }

    function handleSuccess() {
        setRefreshExpenses(!refreshExpenses)
        setModalVisibleDrawer(false);
        setModalDetailDrawer(false)

        if(modalDetailDrawer.type === 'deleteDrawer') {
            toast.success('Sorteio excluído com sucesso!', {
                position: 'top-center'
            })
        }
    }

    

    function toggleModalAction(action) {
        
        if (!content?.length && action === 'fieldAdditional') {
            setModalVisible(true)
            return
        }

        if(action === 'drawer') {
            setModalVisibleDrawer(true)
            return
        }

        if(action.type === 'detailDrawer') {
            setModalDetailDrawer(action)
            return
        }

        if(action.type === 'deleteDrawer') {
           
            setModalDetailDrawer(action)
            return
        }

        if(content?.length && action === 'fieldAdditional') {
            setEdit(content);
            setModalVisible(true);
        }
    }



    return (
        <Container>
            <ToastContainer toasts={toasts} />

            <HeaderContent>
                <Column width='auto'>
                    <Text name='subtitle' color={colors.nightDark}>
                        Configurações adicionais
                    </Text>
                    <Text marginBottom={'10px'} paddingBottom={0}>
                        Personalize e estenda as funcionalidades do seu evento.
                    </Text>
                </Column>

                {/* {
                    !content?.length && (
                        <Button
                            variant='featured'
                            category='squired'
                            onClick={() => setModalVisible(true)}
                        >
                            <PlusSquare color={colors.neutralLight} size={16} />
                            <Text
                                color={colors.neutralLight}
                                paddingBottom={0}
                                marginLeft={'6px'}
                            >
                                Criar campos personalizados
                            </Text>
                        </Button>
                    )
                } */}
            </HeaderContent>

            <BlockContent>
                <ContentHeader>
                    <Column>
                        <Row>
                            <Plus color={colors.secondaryPurple} size={22} />
                            <Text name='highlight' marginLeft={'8px'} paddingBottom={0} color={colors.nightDark}>Campos personalizados</Text>
                        </Row>
                        <Text marginTop={'10px'} paddingBottom={0}>
                            Colete informações extras dos participantes durante a inscrição.
                        </Text>
                    </Column>

                    <ButtonsContainer>
                        <Button
                            variant='featured'
                            category='squired'
                            onClick={() => toggleModalAction('fieldAdditional')}
                        >
                            {content?.length
                                ? <Edit color={colors.neutralLight} size={16} />
                                : <PlusSquare color={colors.neutralLight} size={16} />
                            }

                            <Text
                                color={colors.neutralLight}
                                paddingBottom={0}
                                marginLeft={'6px'}
                            >
                                {content?.length ? 'Editar formulário' : 'Adicionar campos'}
                            </Text>
                        </Button>

                        <DeleteContainer onClick={() => setDeleteModal(true)}>
                            <Trash2
                                size={16}
                                color={colors.danger}
                            />
                        </DeleteContainer>
                    </ButtonsContainer>
                </ContentHeader>

                {
                    loading ? (
                        <ContentLoader>
                            <Loader />
                        </ContentLoader>
                    ) : (
                        <ContainerAdditionalFields>
                            {
                                !content?.length ? (
                                    <ContentCardEmpty>
                                        <Text type='italic' color={colors.night} textAlign={'center'} paddingBottom={0}>
                                            Nenhum campo personalizado criado ainda.
                                        </Text>
                                    </ContentCardEmpty>
                                ) : (
                                    <CustomFieldsContainer>
                                        {content?.map(el => (
                                            <CustomFieldCard data={el} key={el?.id} />
                                        ))}
                                    </CustomFieldsContainer>
                                )
                            }
                        </ContainerAdditionalFields>

                    )


                }
            </BlockContent>


             <BlockContent>
        

                <ContentHeader>
                    <Column>
                        <Row>
                             <Gift color={colors.secondaryPurple} size={22} />
                                <Text name='highlight' marginLeft={'8px'} paddingBottom={0} color={colors.nightDark}>Sorteador</Text>
                        </Row>
                        <Text marginTop={'10px'} paddingBottom={0}>
                           Faça sorteios e distribua prêmios entre os participantes do seu evento.
                        </Text>
                    </Column>

                    <ButtonsContainer>
                        <Button
                            variant='featured'
                            category='squired'
                            onClick={() => toggleModalAction('drawer')}
                        >
                            <Gift color={colors.neutralLight} size={16} />

                            <Text
                                color={colors.neutralLight}
                                paddingBottom={0}
                                marginLeft={'6px'}
                            >
                                Sortear Paricipantes
                            </Text>
                        </Button>
                    </ButtonsContainer>
                </ContentHeader>

                 {
                    loading ? (
                        <ContentLoader>
                            <Loader />
                        </ContentLoader>
                    ) : (
                        (!giveaways?.length || giveaways[0]?.winners?.length === 0) ? (
                            <ContentCardEmpty> 
                                <Text type='italic' color={colors.night} textAlign={'center'} paddingBottom={0}>
                                    Nenhum sorteio criado.
                                </Text>
                            </ContentCardEmpty>
                        ) : (
                            <>
                                {giveaways?.map(el => (
                                    <ListDrawer 
                                        key={el.id}  
                                        giveaway={el} 
                                        isLoading={loading}
                                        toggleAction={toggleModalAction}
                                    />
                                ))}
                                {lastPage > 1 && (
                                    <Paginate
                                    perPage={perPage}
                                    totalItems={totalItems}
                                    lastPage={lastPage}
                                    firstPage={firstPage}
                                    currentPage={currentPage}
                                    marginTop={'20px'}
                                    onPaginate={(number) => getGiveaways(number)}
                                />
                                )}
                            </>
                        )
                        
                    )
                }
            </BlockContent>


            <BlockContent>
                <Column>
                    <Row style={{ 'justifyContent': 'space-between' }}>
                        <Row width='auto'>
                            <Link color={colors.secondaryPurple} size={22} />
                            <Text name='highlight' marginLeft={'8px'} paddingBottom={0} color={colors.nightDark}>Integrações</Text>
                        </Row>
                        <Tip>Em breve</Tip>
                    </Row>

                    <Text marginTop={'10px'} paddingBottom={0}>
                        Conecte seu evento com outras ferramentas e serviços populares.
                    </Text>
                </Column>
            </BlockContent>

            <BlockContent>
                <Column>
                    <Row style={{ 'justifyContent': 'space-between' }}>
                        <Row width='auto'>
                            <Mail color={colors.secondaryPurple} size={22} />
                            <Text name='highlight' marginLeft={'8px'} paddingBottom={0} color={colors.nightDark}>FAQ do evento</Text>
                        </Row>
                        <Tip>Em breve</Tip>
                    </Row>

                    <Text marginTop={'10px'} paddingBottom={0}>
                        Crie uma seção de Perguntas Frequentes para ajudar seus participantes.
                    </Text>
                </Column>
            </BlockContent>

            <BlockContent>
                <Column>
                    <Row style={{ 'justifyContent': 'space-between' }}>
                        <Row width='auto'>
                            <FileMinus color={colors.secondaryPurple} size={22} />
                            <Text name='highlight' marginLeft={'8px'} paddingBottom={0} color={colors.nightDark}>Geração de certificados</Text>
                        </Row>
                        <Tip>Em breve</Tip>
                    </Row>

                    <Text marginTop={'10px'} paddingBottom={0}>
                        Crie e personalize certificados para os participantes do seu evento.
                    </Text>
                </Column>
            </BlockContent>

           

            <BlockContent>
                <Column>
                    <Row style={{ 'justifyContent': 'space-between' }}>
                        <Row width='auto'>
                            <Home color={colors.secondaryPurple} size={22} />
                            <Text name='highlight' marginLeft={'8px'} paddingBottom={0} color={colors.nightDark}>características do local</Text>
                        </Row>
                        <Tip>Em breve</Tip>
                    </Row>

                    <Text marginTop={'10px'} paddingBottom={0}>
                        Destaque as características e comodidades do local, como climatização, espaços instagramáveis e outros diferenciais para o público.
                    </Text>
                </Column>
            </BlockContent>

            {
                modalVisible &&
                <CustomFieldsForm
                    visible={modalVisible}
                    isEdit={edit}
                    toast={toast}
                    onClose={() => {
                        setEdit(false);
                        setModalVisible(false);
                    }}
                    onSuccess={refreshData}
                />
            }



            {
                modalVisibleDrawer && (
                    <CreateDrawer
                        visible={modalVisibleDrawer}
                        slug={event?.slug}
                        onSuccess={() => handleSuccess()}
                        onClose={() => {
                            setModalVisibleDrawer(false);
                        }}
                    />
                )
            }
            {
                modalDetailDrawer?.type == 'detailDrawer' ? (
                    <DetailDrawer
                        modalDetailDrawer={modalDetailDrawer}
                        setModalDetailDrawer={setModalDetailDrawer}
                     />
                ) : (
                    modalDetailDrawer?.type == 'deleteDrawer' && (
                        <Modal isOpen={modalDetailDrawer?.type == 'deleteDrawer'} onClose={() => setModalDetailDrawer(false)}>
                            <Text>Tem certeza que deseja excluir esse sorteio?</Text>

                            {loading ? (
                                <Loader />
                            ) : (
                                <ContentAction>
                                    <Button onClick={() => setModalDetailDrawer(false)} variant='light'>Cancelar</Button>
                                    <Button onClick={() => deleteGiveaway(modalDetailDrawer?.item?.giveaway?.id)}>Confirmar</Button>
                                </ContentAction>
                            )}
                            
                        </Modal>
                    ) 
                )
            }
            {
                deleteModal &&
                <CustomFieldsDeleteModal
                    visible={deleteModal}
                    toast={toast}
                    onClose={() => setDeleteModal(false)}
                    onSuccess={refreshData}
                />
            }

        </Container >
    )
}


const Container = styled(Column)`
    width: 100%;
`;

const HeaderContent = styled(Column)`
    width: 100%;
    padding: 14px 0;
    
    & > button {
        margin-top: 20px;
    }
    
    @media screen and (min-width: ${breakpoints.md}) {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        
        & > h2,
        & > button {
            width: auto;
            margin-top: 0;
        }
        
        
    }
`;

const CustomFieldsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px; 
  width: 100%;

  > div {
    width: 100%;
  }

  @media screen and (min-width: ${breakpoints.lg}) {
    > div {
      /* flex: 0 0 calc((100% - 24px) / 3); // 3 itens, considerando 2 gaps de 24px */
      width: 31.5%;
    }
  }
`;


const Picture = styled.picture`
    width: auto;
    height: 300px;
`;

const ActionButton = styled.div`
    width: auto;
    height: auto;
    transition: all ease-in-out .25s;
    cursor: pointer;

    ${({ disabled }) => disabled && `
        opacity: .4;
        pointer-events: none;
    `};
`;

const DiscountCodesList = styled(Column)`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  width: 100%;

  > div {
    flex: 1 1 calc(33.33% - 16px);
    min-width: 280px;
  }

  @media screen and (max-width: ${breakpoints.lg}) {
    flex-direction: column;

    > div {
      width: 100%;
    }
  }
`;


const ContentLoader = styled(Column)`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ContentCardEmpty = styled.div`
    border: 1px solid ${colors.nightLight};
    background-color: #eee;
    border-radius: 8px;
    padding: 30px 20px;
    width: 100%;
    
    @media screen and (min-width: ${breakpoints.lg}) {
        width: 33.5%;
    }
`;

const ContentHeader = styled(Column)`
    & > div > button {
        margin-top: 20px;
    }
    
    @media screen and (min-width: ${breakpoints.lg}) {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        & > div > button {
            margin-top: 0;
            width: 245px;
        }

    }
`;

const ContainerAdditionalFields = styled(Row)`
    margin-top: 14px;
    width: 100%;
    flex-wrap: wrap;
`;

const DeleteContainer = styled(FullyCentered)`
    width: auto;
    height: auto;
    /* padding: 10px; */
    border: 1px solid ${colors.danger};
    border-radius: 8px;
    margin-left: 8px;
    cursor: pointer;
    padding: 10px;

    @media screen and (min-width: ${breakpoints.lg}) {
        margin-bottom: 10px;
    }

`;

const ButtonsContainer = styled(Row)`
    height: auto;
    width: auto;
    align-items: center;
    margin-top: 6px;
`;

const Tip = styled.div`
    background-color: #F3E8FF;
    color: ${colors.secondaryPurple};
    font-size: ${fonts.sizes.small};
    padding: 4px 12px;
    font-weight: bold;
    border-radius: 30px;
`;

const ContentAction = styled(Column)`
   
    margin-top: 15px;

    @media screen and (min-width: ${breakpoints.md}) {
        flex-direction: row;
        gap: 5px;
    }
`;


    
